import React from 'react';
import ReactDOM from 'react-dom';
import {detect} from 'detect-browser'
import registerServiceWorker from './registerServiceWorker';
import BrowserNotSupportedMessage from './components/BrowserNotSupportedMessage/BrowserNotSupportedMessage';
import { SetLanguageDependingOnBrowserSettings, setLangByShopId } from './assets/creator/translations';

const isInIframe = window.top !== window.self;
if (!isInIframe) {
  if (!(localStorage.getItem('langB2B'))) {
    SetLanguageDependingOnBrowserSettings();
  }
} else {
  const url = new URL(window.location);
  const langId = url.searchParams.get("lngId");
  try {
    setLangByShopId(langId);
  } catch (e) {
    if (!(localStorage.getItem('langB2B'))) {
      SetLanguageDependingOnBrowserSettings();
    }
  }
}

const browser = detect();
if (browser && browser.name !== "ie" && browser.name !== "edge") {
  const App = require("./App").default;
  ReactDOM.render(
    <App isInIframe={isInIframe} />,
    document.getElementById("root")
  );
  registerServiceWorker({});
} else {
  ReactDOM.render(
    <BrowserNotSupportedMessage />,
    document.getElementById("root")
  );
}